import { rem } from 'polished';
import styled from 'styled-components';
import { mediaQueryWidth } from '../../../common/breakpoints';
import { StyledPaddingContainer } from '../../../common/padding.styles';

export const StyledArticleResults = styled(StyledPaddingContainer)`
  background-color: white;

  & > button {
    display: block;
    margin: 10px auto;

    ${mediaQueryWidth({ min: 'mobile' })`
      margin: 40px auto;
    `}
  }
`;

export const StyledArticleNoResults = styled(StyledPaddingContainer)`
  padding-bottom: ${rem(32)};
`;
